import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import { defaultPicture } from "../../../utils";
import MenuUi from "../../../helpers/MenuUi/MenuUi";

const CustomerProfilePage = () => {
  const userInfo = useSelector((state) => state.userInfo);

  return (
    <>
      <SiteTitle title="پروفایل کاربر" />
      <div className="mr-auto w-full h-full">
        <div className="flex h-full justify-end items-center rounded-xl bg-mainBackground relative">
          {/* Menu */}
          <MenuUi className={"top-3"} />
          <div
            className="rounded-xl flex flex-col h-full w-full
             animate__animated animate__fadeIn animate__fast"
          >
            <span className="w-full flex flex-col items-center justify-center h-screen">
              <div
                className="flex flex-col items-center w-full p-5 space-y-5
                text-gray-200 text-xl font-medium text-center"
              >
                {/* Profile */}
                <span className="xl:w-[30%] md:w-[60%] w-full">
                  <img
                    src={defaultPicture}
                    alt="User_Profile"
                    width={135}
                    className="m-auto text-white rounded-full object-cover"
                  />
                </span>
                {/* User Name */}
                <span
                  className="xl:w-[30%] md:w-[60%] w-full p-2 space-y-2
                      flex flex-col justify-between
                      border-2 border-boxColor bg-boxColor rounded-xl"
                >
                  <span>نام کاربر :</span>
                  <span>
                    {userInfo[0]?.firstname} {userInfo[0]?.lastname}
                  </span>
                </span>
                {/* Phone Number */}
                <span
                  className="xl:w-[30%] md:w-[60%] w-full p-2 space-y-2
                      flex flex-col justify-between
                      border-2 border-boxColor bg-boxColor rounded-xl"
                >
                  <span>موبایل :</span>
                  <span>{userInfo[0]?.phonenumber}</span>
                </span>
                {/* National Number */}
                <span
                  className="xl:w-[30%] md:w-[60%] w-full p-2 space-y-2
                      flex flex-col justify-between
                      border-2 border-boxColor bg-boxColor rounded-xl"
                >
                  <span>کد ملی :</span>
                  <span>{userInfo[0]?.nationalid}</span>
                </span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerProfilePage;
